import { useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Bell, Check } from "lucide-react";
import { toast } from "sonner";

/**
 * Public Swahili web subscribe widget.
 * Calls POST /api/public/subscribe -> creates a subscription with source="web".
 * Active subs receive real-time team alerts (goals, cards, full-time) via SMS.
 */
const WebSubscribeWidget = () => {
    const [phone, setPhone] = useState("");
    const [team, setTeam] = useState("");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!phone || !team) {
            toast.error("Weka nambari na timu");
            return;
        }
        setLoading(true);
        try {
            await axios.post(`${API}/public/subscribe`, {
                phone_number: phone.trim(),
                team: team.trim(),
                source: "web",
            });
            setDone(true);
            toast.success("Umesajiliwa! Utapokea taarifa za mechi.");
            setPhone("");
            setTeam("");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Imeshindikana");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card className="bg-gradient-to-br from-electric/10 to-subtle border-electric/30 p-4" data-testid="web-subscribe-widget">
            <div className="flex items-center gap-2 mb-3">
                <Bell className="h-4 w-4 text-electric" />
                <h3 className="text-white font-heading font-bold text-sm uppercase tracking-wider">
                    Pata Taarifa za Mechi
                </h3>
            </div>
            {done ? (
                <div className="flex items-center gap-2 text-electric text-sm py-3" data-testid="web-subscribe-success">
                    <Check className="h-4 w-4" />
                    Umesajiliwa kikamilifu!
                    <button
                        onClick={() => setDone(false)}
                        className="ml-auto text-white/50 text-xs hover:text-white"
                    >
                        Sajili nyingine
                    </button>
                </div>
            ) : (
                <form onSubmit={handleSubmit} className="space-y-2" data-testid="web-subscribe-form">
                    <Input
                        placeholder="Nambari ya simu (+255...)"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        className="bg-subtle border-border text-white h-9 text-sm"
                        data-testid="web-subscribe-phone"
                    />
                    <Input
                        placeholder="Timu (mf. Simba, Arsenal)"
                        value={team}
                        onChange={(e) => setTeam(e.target.value)}
                        className="bg-subtle border-border text-white h-9 text-sm"
                        data-testid="web-subscribe-team"
                    />
                    <Button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-electric hover:bg-vodaredDark text-white h-9 text-sm"
                        data-testid="web-subscribe-submit"
                    >
                        {loading ? "Inasajili..." : "Jiunge Bure"}
                    </Button>
                    <p className="text-white/40 text-[10px] text-center">
                        Utapokea SMS za magoli, kadi nyekundu na matokeo
                    </p>
                </form>
            )}
        </Card>
    );
};

export default WebSubscribeWidget;
